import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createApi } from "@reduxjs/toolkit/query/react";
import persistReducer from "redux-persist/es/persistReducer";
import storage from "redux-persist/es/storage";
import { apiFetchBaseQuery } from "../apiFetchBaseQuery";
import { WhitelabelConfigs, WhitelabelRequestParams, WhitelabelRequestResponse } from "@/types/WhitelabelConfigs";

const initialState: WhitelabelConfigs = {
	root_domain: "",
	ui_base_url: "",
	api_base_url: "",
	logo_url: "",
	whitelabel_logo: "/images/logo-full-light.png",
	whitelabel_parent_agency_id: 0,
	whitelabel_signup_hostname: "",
	whitelabel_signup_tab_active: "#a7e548",
	whitelabel_signup_tab_inactive: "#195f97",
	whitelabel_signup_button: "#195f97",
	whitelabel_signup_header: "",
	whitelabel_signup_from_name: "",
	whitelabel_signup_from_email: "",
	company_name: "ProData Media Group",
	phone: "8557767020",
	address: "601 Heritage Dr, Suite 153A",
	city: "Jupiter",
	state: "FL",
	postal: "33458",
	is_2fa_enabled: "N",
	is_passkey_enabled: "N",
};

const whitelabelConfigSlice = createSlice({
	name: "whitelabelConfigs",
	initialState,
	reducers: {
		setWhitelabelConfigs(state, action: PayloadAction<WhitelabelConfigs>) {
			state.root_domain = action.payload.root_domain;
			state.ui_base_url = action.payload.ui_base_url;
			state.api_base_url = action.payload.api_base_url;
			state.logo_url = action.payload.logo_url;
			state.whitelabel_logo = action.payload.whitelabel_logo;
			state.whitelabel_signup_hostname = action.payload.whitelabel_signup_hostname;
			state.whitelabel_signup_tab_active = action.payload.whitelabel_signup_tab_active;
			state.whitelabel_signup_tab_inactive = action.payload.whitelabel_signup_tab_inactive;
			state.whitelabel_signup_button = action.payload.whitelabel_signup_button;
			state.whitelabel_signup_header = action.payload.whitelabel_signup_header;
			state.whitelabel_signup_from_name = action.payload.whitelabel_signup_from_name;
			state.whitelabel_signup_from_email = action.payload.whitelabel_signup_from_email;
			state.company_name = action.payload.company_name;
			state.phone = action.payload.phone;
			state.address = action.payload.address;
			state.city = action.payload.city;
			state.state = action.payload.state;
			state.postal = action.payload.postal;
		},
	},
});

const filterPersistConfig = {
	key: "whitelabel_configs",
	storage,
};

export const whitelabelConfigsApiSlice = createApi({
	reducerPath: "whitelabelConfigsApiSlice",
	baseQuery: apiFetchBaseQuery,
	tagTypes: ["whitelabelConfigs"],
	endpoints: builder => ({
		getWhitelabelConfigs: builder.query<WhitelabelRequestResponse, WhitelabelRequestParams>({
			query: ({ hostname = "whitelabel" }) => ({
				url: `agency/whitelabel-config?hostname=${hostname}`,
			}),
			providesTags: ["whitelabelConfigs"],
			keepUnusedDataFor: 0,
		}),
	}),
});

export const whitelabelConfigReducer = persistReducer(filterPersistConfig, whitelabelConfigSlice.reducer);
export const { setWhitelabelConfigs } = whitelabelConfigSlice.actions;
export const defaultWhitelabelConfigs = Object.freeze(initialState);
export const { useGetWhitelabelConfigsQuery } = whitelabelConfigsApiSlice;
